import { LogLevel } from '../consts';
import { Transport } from './Transport';

const colors: Record<LogLevel, string> = {
  critical: '\x1b[35m', // Magenta
  error: '\x1b[31m', // Red
  warn: '\x1b[33m', // Yellow
  info: '\x1b[32m', // Green
  verbose: '\x1b[36m', // Cyan
  debug: '\x1b[34m', // Blue
};
const resetColor = '\x1b[0m';

const levelsHandlers: Record<
  LogLevel,
  (message: string, ...args: unknown[]) => void
> = {
  critical: console.error,
  error: console.error,
  warn: console.warn,
  info: console.info,
  verbose: console.log,
  debug: console.debug,
};

export class ConsoleTransport extends Transport {
  private wrapTitle(name: string, level: LogLevel): string {
    const title = name ? `[${name}] [${level}]` : `[${level}]`;

    return `${colors[level]}${title}${resetColor}`;
  }

  private getHandler(level: LogLevel) {
    return levelsHandlers[level];
  }

  log(
    name: string,
    level: LogLevel,
    message: string,
    ...args: unknown[]
  ): void {
    this.getHandler(level)(
      `${this.wrapTitle(name, level)} ${message}`,
      ...args
    );
  }
}
